import { Component, OnInit, OnDestroy } from '@angular/core';
import { Response } from '@angular/http';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs/Rx';
import { EventManager, ParseLinks, PaginationUtil, JhiLanguageService, AlertService } from 'ng-jhipster';

import { MarketdateMeterreading } from './marketdate-meterreading.model';
import { MarketdateMeterreadingService } from './marketdate-meterreading.service';
import { ITEMS_PER_PAGE, Principal } from '../../shared';
import { PaginationConfig } from '../../blocks/config/uib-pagination.config';

@Component({
    selector: 'jhi-marketdate-meterreading',
    templateUrl: './marketdate-meterreading.component.html'
})
export class MarketdateMeterreadingComponent implements OnInit, OnDestroy {
marketdateMeterreadings: MarketdateMeterreading[];
    currentAccount: any;
    eventSubscriber: Subscription;
    currentSearch: string;

    constructor(
        private jhiLanguageService: JhiLanguageService,
        private marketdateMeterreadingService: MarketdateMeterreadingService,
        private alertService: AlertService,
        private eventManager: EventManager,
        private activatedRoute: ActivatedRoute,
        private principal: Principal
    ) {
        this.currentSearch = activatedRoute.snapshot.params['search'] ? activatedRoute.snapshot.params['search'] : '';
        this.jhiLanguageService.setLocations(['marketdateMeterreading', 'timestampType']);
    }

    loadAll() {
        if (this.currentSearch) {
            this.marketdateMeterreadingService.search({
                query: this.currentSearch,
                }).subscribe(
                    (res: Response) => this.marketdateMeterreadings = res.json(),
                    (res: Response) => this.onError(res.json())
                );
            return;
       }
        this.marketdateMeterreadingService.query().subscribe(
            (res: Response) => {
                this.marketdateMeterreadings = res.json();
                this.currentSearch = '';
            },
            (res: Response) => this.onError(res.json())
        );
    }

    search(query) {
        if (!query) {
            return this.clear();
        }
        this.currentSearch = query;
        this.loadAll();
    }

    clear() {
        this.currentSearch = '';
        this.loadAll();
    }
    ngOnInit() {
        this.loadAll();
        this.principal.identity().then((account) => {
            this.currentAccount = account;
        });
        this.registerChangeInMarketdateMeterreadings();
    }

    ngOnDestroy() {
        this.eventManager.destroy(this.eventSubscriber);
    }

    trackId(index: number, item: MarketdateMeterreading) {
        return item.id;
    }
    registerChangeInMarketdateMeterreadings() {
        this.eventSubscriber = this.eventManager.subscribe('marketdateMeterreadingListModification', (response) => this.loadAll());
    }

    private onError(error) {
        this.alertService.error(error.message, null, null);
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/marketdate-meterreading/marketdate-meterreading.component.ts